export default __webpack_public_path__ + "static/media/poweredbytraclogik.d0b71f91.png";